var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenymotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#F9F9F9;fill-opacity:0.85;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Genymotion"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 717.9917,
    y1: 695.6349,
    x2: 716.7334,
    y2: 592.9933,
    gradientTransform: "matrix(0.49 0 0 0.48 -286.49 -262.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E61A5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6C9D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,20L65,20c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0c-13.8,0-25-11.2-25-25l0,0 C40,31.2,51.2,20,65,20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.8,36.1c-4.9,0-8.9,4-8.9,8.9s4,8.9,8.9,8.9c4.9,0,8.9-4,8.9-8.9l0,0C81.7,40.1,77.7,36.1,72.8,36.1  M72.8,38.3c3.7,0,6.7,3,6.7,6.7s-3,6.7-6.7,6.7s-6.7-3-6.7-6.7S69.1,38.3,72.8,38.3z M55,39.4c-3.7,0-6.7,3-6.7,6.7 s3,6.7,6.7,6.7s6.7-3,6.7-6.7S58.7,39.4,55,39.4 M55,41.7c2.5,0,4.4,2,4.4,4.5c0,2.5-2,4.4-4.5,4.4c-2.5,0-4.4-2-4.4-4.5 c0,0,0,0,0,0C50.5,43.7,52.5,41.7,55,41.7C55,41.7,55,41.7,55,41.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenymotion);
export default __webpack_public_path__ + "static/media/Genymotion.45c392e4ac3051da51ec92f202e52838.svg";
export { ForwardRef as ReactComponent };